export enum ProfilePlayerSeasonFlag {
  Injured = 'injured',
  Banned = 'banned',
  New = 'new',
  Captain = 'captain',
  ViceCaptain = 'viceCaptain',
}
